import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "drawer-content lesson-form" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "buttons" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-pencil" }, null, -1)
const _hoisted_8 = ["textContent"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text" }, "Cancel", -1)
const _hoisted_10 = [
  _hoisted_9
]

import { computed, onMounted, reactive } from "vue";
import { useStore } from "vuex";
import useVuelidate from "@vuelidate/core";
import { Actions } from "@/store";
import { Lesson, lessonValidations } from "@/models/lesson";
import Loading from "@/components/common/Loading.vue";
import Field from "@/components/common/Field.vue";
import { useLoading } from "../common/loading.composable";
import FieldChoice, { Item } from "../common/FieldChoice.vue";
import { Application } from "@/models/application";
import FieldNumber from "../common/FieldNumber.vue";
import FieldLong from "../common/FieldLong.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LessonForm',
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const lesson = reactive<Lesson>({
  ...store.state.lesson
});
const isNew = computed<boolean>(() => lesson.id === -1);
const applicationOptions = computed<Item[]>(() => [
  { label: "None", value: undefined },
  ...store.state.applications.map((app: Application) => ({
    label: app.name,
    value: app.id
  }))
]);
const { loading, setLoading } = useLoading();

onMounted(() => {
  store.dispatch(Actions.GetApplications);

  store.dispatch(Actions.NewLesson);
  Object.assign(lesson, { ...store.state.lesson });
});

const $v = useVuelidate(lessonValidations, { lesson });
const emit = __emit;

const submit = async () => {
  $v.value.$touch();
  if (!$v.value.$invalid) {
    setLoading(true);
    await store.dispatch(Actions.StoreLesson, lesson);

    setLoading(false);
    await store.dispatch(Actions.NewLesson);
    cancel();
  }
};

const cancel = () => {
  emit("close");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    lesson
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          onSubmit: _withModifiers(submit, ["prevent"]),
          class: _normalizeClass({ submitting: _unref(loading) })
        }, [
          _createElementVNode("h2", {
            textContent: _toDisplayString(isNew.value ? 'Add lesson' : 'Edit lesson')
          }, null, 8, _hoisted_2),
          (isNew.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Fill out the details of the lesson"))
            : (_openBlock(), _createElementBlock("p", _hoisted_4, "Edit the details of the lesson")),
          _createVNode(Field, {
            label: "Name",
            validation: _unref($v).lesson.name,
            modelValue: lesson.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((lesson.name) = $event))
          }, null, 8, ["validation", "modelValue"]),
          _createVNode(Field, {
            label: "Author",
            validation: _unref($v).lesson.author,
            modelValue: lesson.author,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((lesson.author) = $event))
          }, null, 8, ["validation", "modelValue"]),
          _createVNode(FieldLong, {
            label: "Description",
            validation: _unref($v).lesson.description,
            modelValue: lesson.description,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((lesson.description) = $event))
          }, null, 8, ["validation", "modelValue"]),
          _createVNode(Field, {
            label: "Url",
            validation: _unref($v).lesson.url,
            modelValue: lesson.url,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((lesson.url) = $event))
          }, null, 8, ["validation", "modelValue"]),
          _createVNode(FieldNumber, {
            label: "Year",
            validation: _unref($v).lesson.year,
            modelValue: lesson.year,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((lesson.year) = $event)),
            modelModifiers: { number: true }
          }, null, 8, ["validation", "modelValue"]),
          _createVNode(FieldChoice, {
            label: "Application",
            modelValue: lesson.application_id,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((lesson.application_id) = $event)),
            items: applicationOptions.value
          }, null, 8, ["modelValue", "items"]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "confirm",
              type: "button",
              disabled: _unref(loading),
              onClick: submit
            }, [
              _hoisted_7,
              _createElementVNode("span", {
                class: "text",
                textContent: _toDisplayString(isNew.value ? 'Add' : 'Edit')
              }, null, 8, _hoisted_8)
            ], 8, _hoisted_6),
            _createElementVNode("button", {
              class: "cancel",
              type: "button",
              onClick: cancel
            }, _hoisted_10),
            (_unref(loading))
              ? (_openBlock(), _createBlock(Loading, { key: 0 }))
              : _createCommentVNode("", true)
          ])
        ], 34))
      : _createCommentVNode("", true)
  ]))
}
}

})